import { render, staticRenderFns } from "./titleWidge.vue?vue&type=template&id=46808543&scoped=true"
import script from "./titleWidge.vue?vue&type=script&lang=js"
export * from "./titleWidge.vue?vue&type=script&lang=js"
import style0 from "./titleWidge.vue?vue&type=style&index=0&id=46808543&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46808543",
  null
  
)

export default component.exports